import React, { useContext } from "react";
import { HeaderContext } from "../../../../store/context/header-context";
import { SlideDown } from "react-slidedown";
import Burger from "./Burger";
import Auth from "../Auth";
import LanguageSwitcher from "../LanguageSwitcher";
import loadable from "@loadable/component";
import "./index.scss";

const DropMenu = loadable(() => import("./DropMenu"));

const MobilePanel = () => {
  const { getState, isDesktop, language, isShowLanguageSwitcher } =
    useContext(HeaderContext);
  if (isDesktop) return null;

  return (
    <>
      <div className="GCL-H-MP">
        {isShowLanguageSwitcher && <LanguageSwitcher language={language} />}
        <Auth />
        <Burger />
      </div>
      <SlideDown className="my-dropdown-slidedown">
        {getState.isOpen ? <DropMenu /> : null}
      </SlideDown>
    </>
  );
};
export default MobilePanel;
